import React from "react";

import nameof from "ts-nameof.macro";
import { withRouter } from "react-router-dom";
import { ClientContext } from "../../utils/ClientContext";
import { ComponentBase } from "../../utils/base/ComponentBase";
import { ModelValidation } from "../../utils/base/ModelValidation";
import { MiColegioEditModel, TipoUsuario } from "../../models/dataModels";
import { MiPerfilColegioService } from "./MiPerfilColegioService";
import { Modal, ModalHeader, ModalBody, ModalFooter, TabContent, TabPane, NavItem, Nav, NavLink, Col, FormGroup, Input, Label, Row, FormFeedback, Button } from "reactstrap";
import { I18n } from "../../utils/I18n";
import { DocumentUpload } from "../../helpers/DocumentUpload";
import { SyncIcon, SaveIcon } from "../../utils/Icons";
import { AlertsService } from "../../utils/AlertsService";
import { Loading } from "../../utils/Loading";
import { Index as CursosEscolares } from "../../cursoEscolar/Index";
import { Index as Credenciales } from "../../credenciales/Index";
import { RouteHelper } from "../../IntranetRouter";
import { CustomDatePicker } from "../../helpers/CustomDatePicker";

import { NavigationHelper } from "../../utils/base/Breadcrumb";
import { DropDownButton } from "../../helpers/DropDownButton";
import { ComunidadesAutonomasDropDown } from "../../comunidadesAutonomas/ComunidadesAutonomasDropDown";
import { YesNoCancelModal } from "../../utils/YesNoCancelModal";


interface MyProfileState {
    showLoading: boolean;
    editModel: MiColegioEditModel;
    validationResult: ModelValidation;
    searchValidationResult: ModelValidation;
    activeTab: ColegioEditTabs;
}

export enum ColegioEditTabs {
    Datos = "datos",
    CursoEscolar = "curso-escolar",
    Credenciales = "credenciales",
}

export class EditComp extends ComponentBase<any, MyProfileState> {

    public constructor(props: any) {
        super(props);

        let datosCursoEscolar = ClientContext.Current.cursosEscolares.find(ce => ce.id == ClientContext.Current.cursoEscolarActivoId);

        this.state = {
            editModel: null,
            showLoading: true,
            validationResult: new ModelValidation(),
            searchValidationResult: new ModelValidation(),
            activeTab: ColegioEditTabs.Datos,           
        };


    }

    protected updateBreadCrumb(model: MiColegioEditModel) {
        var items = [{
            text: I18n.Strings.schoolProfile,
            link: RouteHelper.myProfileSchool(ColegioEditTabs.Datos)
        }];

        switch (this.state.activeTab) {
            case ColegioEditTabs.Datos: {
                items.push({ text: I18n.Strings.colegio.tabDatos, link: RouteHelper.myProfileSchool(ColegioEditTabs.Datos) });
                break;
            }
            case ColegioEditTabs.Credenciales: {
                items.push({ text: I18n.Strings.colegio.tabCredenciales, link: RouteHelper.myProfileSchool(ColegioEditTabs.Credenciales) });
                break;
            }
            case ColegioEditTabs.CursoEscolar: {
                items.push({ text: I18n.Strings.colegio.tabCursoEscolar, link: RouteHelper.myProfileSchool(ColegioEditTabs.CursoEscolar) });
                break;
            }
        }
        NavigationHelper.setBreadcrumbItems(items);
    }

    componentDidMount() {
        var service = new MiPerfilColegioService();
        service.getMyEditModel()
            .then(myData => {
                this.setState({
                    showLoading: false,
                    editModel: myData,
                    activeTab: this.props.match.params.tab
                }, () => this.updateBreadCrumb(this.state.editModel));

            })
            .catch((err) => {
                this.setState({ showLoading: false }, () => AlertsService.showError(err))
            });
    }

    protected _validateModelLocal(): ModelValidation {
        let validation = new ModelValidation();

        if ((this.state.editModel.nombre || "").trim().length == 0) {
            validation.addError(nameof(this.state.editModel.nombre), I18n.Strings.validationErrors.valueRequired(I18n.Strings.colegioUsuarios.nombre));
        }

        if (this.state.editModel.comunidadAutonomaId == null) {
            validation.addError(nameof(this.state.editModel.comunidadAutonomaId), I18n.Strings.validationErrors.valueRequired(I18n.Strings.colegio.comunidadAutonoma));
        }

        return validation;
    }

    protected _validateState(): Promise<ModelValidation> {

        var validationProm = Promise.resolve<ModelValidation>(this._validateModelLocal())
            .then(localValidationResult => {
                if (localValidationResult.isOk) {
                    var service = new MiPerfilColegioService();

                    // Si en local ha ido bien, probamos en remoto, si no, no lo intentamos
                    return service.validate(this.state.editModel)
                        .then(serverValResult => {
                            var validation = new ModelValidation();
                            validation.load(serverValResult);
                            return validation;
                        });
                }
                else {
                    return localValidationResult;
                }
            })
            .catch((reason) => {
                AlertsService.showError(reason);
                return reason;
            });

        return validationProm;
    }

    protected _validateAndSubmit(): void {
        this._validateState()
            .then(validationResultTemp => {

                if (validationResultTemp == null) {
                    alert("error validation");
                    return false;
                }
                var validationResult = new ModelValidation();
                validationResult.load(validationResultTemp);

                if (validationResult.isOk) {
                    console.info("La validación es correcta");

                    var state = this._cloneStateForSetState();
                    state.showLoading = true;
                    state.validationResult = validationResult;
                    this.setState(state, () => {
                        var service = new MiPerfilColegioService();
                        service.update(this.state.editModel)
                            .then((data) => {
                                this.setState({
                                    showLoading: false,
                                }, () => {
                                    ClientContext.Current.nombreColegio = this.state.editModel.nombre;
                                    if (data.error !== null) {
                                        AlertsService.showErrorMessage(data.error);
                                    }
                                    else {
                                        AlertsService.showSuccessMessage(I18n.Strings.savedOk);
                                    }

                                });

                                return;
                            })
                            .catch((reason) => AlertsService.showError(reason));
                    });
                }
                else {
                    console.log("Validación no correcta");
                    console.warn(validationResult);
                    this._processValidationError(validationResult);
                }
            })
            .catch((reason) => AlertsService.showError(reason));
    }


    protected _processValidationError(validation: ModelValidation): void {
        var newState = this._cloneStateForSetState();
        newState.validationResult = validation;
        this.setState(newState);
    }

    protected _errorMessage(fieldName: string): JSX.Element {
        var error = this.state.validationResult.getError(fieldName);
        if (error) {
            return <FormFeedback>{error}</FormFeedback>;
        }
        return null;
    }

    protected _searchErrorMessage(fieldName: string): JSX.Element {
        var error = this.state.searchValidationResult.getError(fieldName);
        if (error) {
            return <FormFeedback>{error}</FormFeedback>;
        }
        return null;
    }

    protected _errorClass(fieldName: string): string {
        var error = this.state.validationResult.getError(fieldName);
        if (error) {
            return "is-invalid";
        }
        return null;
    }

   

    render() {
        var botones = this._getBotones();

        return <React.Fragment>




            <div className="head-seccion">
                <h2>
                    <strong>Perfil del colegio</strong>
                </h2>
            </div>
           
            <Nav tabs>
                <NavItem>
                    <NavLink
                        active={(this.state.activeTab || ColegioEditTabs.Datos) == ColegioEditTabs.Datos}
                        onClick={() => this.setState({ activeTab: ColegioEditTabs.Datos },
                            () => {
                                this.props.history.push(RouteHelper.myProfileSchool(ColegioEditTabs.Datos));
                                this.updateBreadCrumb(this.state.editModel);
                            }
                        )}
                    >
                        {I18n.Strings.colegio.tabDatos}
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={this.state.activeTab == ColegioEditTabs.CursoEscolar}
                        onClick={() => this.setState({ activeTab: ColegioEditTabs.CursoEscolar },
                            () => {
                                this.props.history.push(RouteHelper.myProfileSchool(ColegioEditTabs.CursoEscolar));
                                this.updateBreadCrumb(this.state.editModel);
                            }
                        )}
                    >
                        {I18n.Strings.colegio.tabCursoEscolar}
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        active={this.state.activeTab == ColegioEditTabs.Credenciales}
                        onClick={() => this.setState({ activeTab: ColegioEditTabs.Credenciales },
                            () => {
                                this.props.history.push(RouteHelper.myProfileSchool(ColegioEditTabs.Credenciales));
                                this.updateBreadCrumb(this.state.editModel);
                            }
                        )}
                    >
                        {I18n.Strings.colegio.tabCredenciales}
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={this.state.activeTab || ColegioEditTabs.Datos}>
                <TabPane tabId={ColegioEditTabs.Datos}>
                    {this._paintMainForm()}
                </TabPane>
                <TabPane tabId={ColegioEditTabs.CursoEscolar}>
                    <CursosEscolares isEmbedded={true} {...this.props.history} />
                </TabPane>
                <TabPane tabId={ColegioEditTabs.Credenciales}>
                    <Credenciales isEmbedded={true} {...this.props.history} />
                </TabPane>
            </TabContent>
            <Row className="accesos-directos">
                <Col xs="6" md="4" lg="4">

                    <Button id="save" color="primary" className="btn-rounded" onClick={() => this._validateAndSubmit()} >
                        <SaveIcon />
                        {I18n.Strings.save}
                    </Button>
                </Col>
                <Col xs="6" md="8" lg="8" className="text-end">
                    <DropDownButton botones={botones} />
                </Col>
            </Row>
        </React.Fragment>;
    };

    protected _getBotones(): JSX.Element[] {
        var botones = [];

       

        if (ClientContext.Current.tipoUsuario == TipoUsuario.AdminGlobal) {

            botones.push(<Button color="secondary" className="btn-rounded"
                onClick={() => {
                    var service = new MiPerfilColegioService();
                    service.getServerIp()
                        .then((response) => {
                            alert(response);
                        })
                        .catch((err) => this.setState({ showLoading: false }, () => AlertsService.showError(err)));
                }}
            >
                {I18n.Strings.utils.getServerIp}
            </Button>);



            botones.push(<Button id="fixCredenciales" color="secondary"
                className="btn-rounded"
                onClick={() => {
                    this.setState({ showLoading: true },
                        () => {
                            var service = new MiPerfilColegioService();
                            service.fixCredenciales()
                                .then(ret => {
                                    this.setState({ showLoading: false }, () => {
                                        AlertsService.showSuccessMessage(I18n.Strings.ok);
                                    });
                                })
                                .catch((err) => this.setState({ showLoading: false }, () => AlertsService.showError(err)));

                        });
                }} >
                <SyncIcon />
                Arreglar credenciales
            </Button>);

            botones.push(<Button id="crearUsuarios" color="secondary"
                className="btn-rounded"
                onClick={() => {
                    this.setState({ showLoading: true },
                        () => {
                            var service = new MiPerfilColegioService();
                            service.crearUsuarios()
                                .then(ret => {
                                    this.setState({ showLoading: false }, () => {
                                        AlertsService.showSuccessMessage(I18n.Strings.ok);
                                    });
                                })
                                .catch((err) => this.setState({ showLoading: false }, () => AlertsService.showError(err)));

                        });
                }} >
                <SyncIcon />
                Crear usuarios
            </Button>);

            botones.push(<Button id="fixClasesPorDefecto" color="secondary"
                className="btn-rounded"
                onClick={() => {
                    this.setState({ showLoading: true },
                        () => {
                            var service = new MiPerfilColegioService();
                            service.fixClasesPorDefecto()
                                .then(ret => {
                                    this.setState({ showLoading: false }, () => {
                                        AlertsService.showSuccessMessage(I18n.Strings.ok);
                                    });
                                })
                                .catch((err) => this.setState({ showLoading: false }, () => AlertsService.showError(err)));

                        });
                }} >
                <SyncIcon />
                Arreglar clases por defecto
            </Button>);
        }

        return botones;
    }

    private _paintMainForm(): JSX.Element {
        return <React.Fragment>
            {this.state.showLoading && <Loading />}
            {this.state.editModel != null && <Row>
                <Col md={9}>
                    <Row>
                        <Col md={5}>
                            <FormGroup>
                                <Label for={"usuarios" + nameof(this.state.editModel.nombre)}>{I18n.Strings.colegio.nombre}</Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.nombre = evt.target.value;
                                        this.setState(state);
                                    }}
                                    type="text"
                                    required={true}
                                    maxLength={100}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.nombre))}
                                    name={nameof(this.state.editModel.nombre)}
                                    id={"usuarios" + nameof(this.state.editModel.nombre)}
                                    value={this.state.editModel.nombre || ""}
                                />
                                {this._errorMessage(nameof(this.state.editModel.nombre))}
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <ComunidadesAutonomasDropDown
                                    label={I18n.Strings.colegio.comunidadAutonoma}
                                    onChanged={(comunidadId, comunidadNombre) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.comunidadAutonomaId = comunidadId;
                                        state.editModel.comunidadAutonoma = comunidadNombre;
                                        this.setState(state);
                                    }}
                                    id={nameof(this.state.editModel.comunidadAutonomaId)}
                                    selectedItemValue={this.state.editModel.comunidadAutonomaId || 0}
                                    selectedItemText={this.state.editModel.comunidadAutonoma || ""}
                                    emptyText=""
                                />
                                {this._errorMessage(nameof(this.state.editModel.comunidadAutonomaId))}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for={"usuarios" + nameof(this.state.editModel.codMinisterio)}>{I18n.Strings.colegio.codMinisterio}</Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.codMinisterio = evt.target.value;
                                        this.setState(state);
                                    }}
                                    type="text"
                                    required={false}
                                    maxLength={50}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.codMinisterio))}
                                    name={nameof(this.state.editModel.codMinisterio)}
                                    id={"usuarios" + nameof(this.state.editModel.codMinisterio)}
                                    value={this.state.editModel.codMinisterio || ""}
                                />
                                {this._errorMessage(nameof(this.state.editModel.codMinisterio))}
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.sincronizar)}>{I18n.Strings.colegio.sincronizar}</Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.sincronizar = evt.target.checked;
                                        this.setState(state);
                                    }}
                                    type="checkbox"
                                    style={{ padding: 0 }}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.sincronizar))}
                                    name={nameof(this.state.editModel.sincronizar)}
                                    id={nameof(this.state.editModel.sincronizar)}
                                    checked={this.state.editModel.sincronizar || false}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.sincronizarLicencias)}>
                                    {I18n.Strings.colegio.sincronizarLicencias}
                                </Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.sincronizarLicencias = evt.target.checked;
                                        this.setState(state);
                                    }}
                                    type="checkbox"
                                    style={{ padding: 0 }}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.sincronizarLicencias))}
                                    name={nameof(this.state.editModel.sincronizarLicencias)}
                                    id={nameof(this.state.editModel.sincronizarLicencias)}
                                    checked={this.state.editModel.sincronizarLicencias || false}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={5}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.nombreColegioPedidosTienda)}>
                                    {I18n.Strings.colegio.nombreColegioPedidosTienda}
                                </Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.nombreColegioPedidosTienda = evt.target.value;
                                        this.setState(state);
                                    }}
                                    type="text"
                                    required={false}
                                    maxLength={150}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.nombreColegioPedidosTienda))}
                                    name={nameof(this.state.editModel.nombreColegioPedidosTienda)}
                                    id={"nombreColegioPedidosTienda"}
                                    value={this.state.editModel.nombreColegioPedidosTienda || ""}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={7}>
                            <FormGroup>
                                <Label for={"identificadorCategoriaTienda" + nameof(this.state.editModel.dominiosAutorizados)}>{I18n.Strings.colegio.dominiosAutorizados}</Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.dominiosAutorizados = evt.target.value;
                                        this.setState(state);
                                    }}
                                    type="text"
                                    required={false}
                                    maxLength={500}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.dominiosAutorizados))}
                                    name={nameof(this.state.editModel.dominiosAutorizados)}
                                    id={"dominiosAutorizados"}
                                    value={this.state.editModel.dominiosAutorizados || ""}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.allowGoogleLogin)}>
                                    {I18n.Strings.colegio.allowGoogleLogin}</Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.allowGoogleLogin = evt.target.checked;
                                        this.setState(state);
                                    }}
                                    type="checkbox"
                                    style={{ padding: 0 }}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.allowGoogleLogin))}
                                    name={nameof(this.state.editModel.allowGoogleLogin)}
                                    id={"allowGoogleLogin"}
                                    checked={this.state.editModel.allowGoogleLogin || false}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.allowMicrosoftLogin)}>
                                    {I18n.Strings.colegio.allowMicrosoftLogin}</Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.allowMicrosoftLogin = evt.target.checked;
                                        this.setState(state);
                                    }}
                                    type="checkbox"
                                    style={{ padding: 0 }}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.allowMicrosoftLogin))}
                                    name={nameof(this.state.editModel.allowMicrosoftLogin)}
                                    id={"allowMicrosoftLogin"}
                                    checked={this.state.editModel.allowMicrosoftLogin || false}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.allowCustomLogin)}>
                                    {I18n.Strings.colegio.allowCustomLogin}</Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.allowCustomLogin = evt.target.checked;
                                        this.setState(state);
                                    }}
                                    type="checkbox"
                                    style={{ padding: 0 }}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.allowCustomLogin))}
                                    name={nameof(this.state.editModel.allowCustomLogin)}
                                    id={"allowCustomLogin"}
                                    checked={this.state.editModel.allowCustomLogin || false}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.comunicarAsignacionLicencias)}>
                                    {I18n.Strings.colegio.comunicarAsignacionLicencias}</Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.comunicarAsignacionLicencias = evt.target.checked;
                                        this.setState(state);
                                    }}
                                    type="checkbox"
                                    style={{ padding: 0 }}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.comunicarAsignacionLicencias))}
                                    name={nameof(this.state.editModel.comunicarAsignacionLicencias)}
                                    id={"comunicarAsignacionLicencias"}
                                    checked={this.state.editModel.comunicarAsignacionLicencias || false}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for={nameof(this.state.editModel.comunicarCredencialesLicenciasAlAsignar)}>
                                    {I18n.Strings.colegio.comunicarCredencialesLicenciasAlAsignar}</Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.comunicarCredencialesLicenciasAlAsignar = evt.target.checked;
                                        this.setState(state);
                                    }}
                                    type="checkbox"
                                    style={{ padding: 0 }}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.comunicarCredencialesLicenciasAlAsignar))}
                                    name={nameof(this.state.editModel.comunicarCredencialesLicenciasAlAsignar)}
                                    id={"comunicarCredencialesLicenciasAlAsignar"}
                                    checked={this.state.editModel.comunicarCredencialesLicenciasAlAsignar || false}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={8}>
                            <FormGroup>
                                <Label for={"usuarios" + nameof(this.state.editModel.emailColegio)}>{I18n.Strings.colegio.emailColegio}</Label>
                                <Input
                                    onChange={(evt) => {
                                        var state = this._cloneStateForSetState();
                                        state.editModel.emailColegio = evt.target.value;
                                        this.setState(state);
                                    }}
                                    type="text"
                                    required={true}
                                    maxLength={100}
                                    className={"form-control " + this._errorClass(nameof(this.state.editModel.emailColegio))}
                                    name={nameof(this.state.editModel.emailColegio)}
                                    id={"usuarios" + nameof(this.state.editModel.emailColegio)}
                                    value={this.state.editModel.emailColegio || ""}
                                />
                                {this._errorMessage(nameof(this.state.editModel.emailColegio))}
                            </FormGroup>
                        </Col>
                    </Row>
                </Col>
                <Col md={3}>
                    <div>
                        <div className="mainPhoto">
                            <img
                                className="mt-xl"
                                src={this.state.editModel.foto == null ? '/img/caratula.png' : this.state.editModel.foto}
                            />
                            {this.state.editModel.foto != null && <div className="mainPhotoMenu">

                            </div>
                            }
                        </div>
                        {this.state.editModel.id > 0 && <div>
                            <DocumentUpload
                                manualUpload={false}
                                style={{ fontSize: 14, overflow: "ellipsis" }}
                                title={I18n.Strings.colegio.subirFoto}
                                zoneStyle={{ margin: 0, padding: 10 }}
                                uploadUrl={`intranet/miPerfilColegio/updateProfilePhoto`}
                                multiple={false}
                                onUpload={(data) => {
                                    this._updateStateValue(data.documentUrl, nameof.full(this.state.editModel.foto, 2));
                                    ClientContext.Current.logoColegioUrl = this.state.editModel.foto;
                                }}
                            />
                        </div>}
                    </div>
                </Col>
            </Row>}
        </React.Fragment>;
    }
}

export const Edit = withRouter(EditComp)